import { useRef } from 'react'
import { Col, Image } from 'antd'
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { Request3 } from 'src/common/Request3'
import api from 'src/common/api'
import { CONFIG_URL } from 'src/helpers/constants'

const UPLOAD_FILE_TYPE = '.jpg, .jpeg, .png'

type UploadableImageBoxProps = {
   value?: File | string
   onChange: (fileName?: string) => void
   label: string
}

const UploadableImageBox = ({ value, onChange, label }: UploadableImageBoxProps) => {
   const fileInputRef = useRef<HTMLInputElement | null>(null)

   const handleUploadImage = async (file: any) => {
      try {
         const { data } = await Request3.uploadFile(file, api.upload.uploadFile)
         console.log('handleUploadImage', data)
         onChange(data?.filename)
      } catch (error) {
         console.log(error)
      }
   }
   const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0]
      console.log('file', file)

      if (file) {
         handleUploadImage(file)
      }
      if (fileInputRef.current) fileInputRef.current.value = ''
   }

   const handleRemove = () => {
      onChange(undefined)
   }
   console.log('====================================')
   console.log("CONFIG_URL.IMAGE_URL + '/' + value", CONFIG_URL.IMAGE_URL + '/' + value)
   console.log('====================================')

   return (
      <Col xs={8} style={{ padding: 10 }}>
         {value ? (
            <div style={{ position: 'relative' }}>
               <Image
                  src={typeof value === 'string' ? CONFIG_URL.IMAGE_URL + '/' + value : URL.createObjectURL(value)}
                  alt={label}
                  style={{ borderRadius: 10 }}
                  preview={{ mask: null }}
               />
               {/* <div style={{ textAlign: 'center', fontSize: 11, paddingTop: 4,color:'#161C24' }}>{label}</div> */}
               <div
                  style={{
                     backgroundColor: '#161C2470',
                     height: 22,
                     width: 22,
                     borderRadius: 11,
                     position: 'absolute',
                     top: 16,
                     right: 16,
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     cursor: 'pointer'
                  }}
                  onClick={handleRemove}
               >
                  <CloseOutlined style={{ color: '#fff' }} />
               </div>
            </div>
         ) : (
            <div
               onClick={() => fileInputRef.current?.click()}
               style={{
                  height: 120,
                  borderRadius: 10,
                  border: '2px dashed #ccc',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
               }}
            >
               <PlusCircleOutlined style={{ fontSize: 32, color: '#aaa' }} />
            </div>
         )}

         <input ref={fileInputRef} type="file" accept={UPLOAD_FILE_TYPE} hidden onChange={handleSelect} />
         <div style={{ textAlign: 'center', fontSize: 11, paddingTop: 4, color: '#161C24' }}>{label}</div>
      </Col>
   )
}

export default UploadableImageBox
